export const PROJECT_DELETE_RESET = 'PROJECT_DELETE_RESET'
export const PROJECT_DELETE_SET_ERROR = 'PROJECT_DELETE_SET_ERROR'
export const PROJECT_DELETE_SET_DELETED = 'PROJECT_DELETE_SET_DELETED'
export const PROJECT_DELETE_TOGGLE_LOADING = 'PROJECT_DELETE_TOGGLE_LOADING'
